import { Component } from '@angular/core';

@Component({
  selector: 'fgb-home-layout',
  templateUrl: './home-layout.component.html',
  styleUrl: './home-layout.component.scss',
})
export class HomeLayoutComponent {}
